import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Institution} from "../../models/institution";
import {InstitutionRegistrationRelations} from "../../models/institution_registration_relations";
import {PagedData} from "../../models/paged-data";
import Helpers from "../../utils/helpers";

@Injectable()
export class InstitutionRegistrationsControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getInstitutionRegistrationsRelationsList(serviceId: string, institutions: Institution[]): Observable<InstitutionRegistrationRelations[][]> {
    Helpers.trimRecursiveObj(institutions);
    const body = JSON.stringify(institutions);
    return this.http.post(this.baseUrl + "service/" + serviceId + "/institution_registration_relations", body) as Observable<InstitutionRegistrationRelations[][]>;
    }

    public getInstitutionRegistrationsRelationsListByPage(serviceId: string, pageSize: number, pageNr: number, institutions: Institution[]): Observable<PagedData> {
      Helpers.trimRecursiveObj(institutions);
      const body = JSON.stringify(institutions);
      return this.http.post(this.baseUrl + "service/" + serviceId + "/institution_registration_relations/" + pageSize + "/page/" + pageNr, body) as Observable<PagedData>;
    }

  public saveInstitutionRegistrations(serviceId: string, institutionRegistrationRelations: InstitutionRegistrationRelations) {
    Helpers.trimRecursiveObj(institutionRegistrationRelations);
    const body = JSON.stringify(institutionRegistrationRelations);
    return this.http.post(this.baseUrl + "institution_registration_relations", body);
  }

}
